module.exports = "/_next/static/images/06ca86b31fccbb5b5ba279dfa953e2a6-worldcup-lg-2x.jpg";